import {
    useState,
} from "react";

import './NavBar.css';


import useMediaQuery from '@material-ui/core/useMediaQuery';


import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import MenuItemButton from "./MenuItemButton";
import { Container, Grid } from '@material-ui/core';

export default function NavBar2(props) {

    const mobile = useMediaQuery('(max-width:960px)');

    let navBar;

    if (mobile) {
        navBar = (
            <MobileNavbar></MobileNavbar>
        );
      } else {
        navBar = (
            <DesktopNavbar></DesktopNavbar>
        );
    }

    return (
        <AppBar 

            position="static" 
            elevation={0}
            style={{
                backgroundColor: 'transparent',
                position:'absolute',
                
            }}
           
        >
            {navBar}
            
      </AppBar>
    )
}

function DesktopNavbar(){

    return(
        <Toolbar className="toolbar">
            <Button
                size = "large"

                className="logo-button"

            ></Button>

            <div
                style={{
                    flexGrow: '1',     
                }}>

            </div>

                <MenuItemButton> TJÄNSTER </MenuItemButton>

                <MenuItemButton> OM OSS </MenuItemButton>
       
                
            <Button 
                variant="outlined"
                style={{
                    color: `whitesmoke`,
                    borderColor: 'whitesmoke',
                    borderRadius:'15px',
                    borderWidth: '2px',
                }}
                    
            >KONTAKT</Button>
        </Toolbar>

    )
}

function MobileNavbar(){

    const [show, setShow] = useState(false)

    return(
        <>
            <Toolbar className="toolbar">
                <Container>
                    <Grid
                        container
                        direction="row"
                        justifycontent="center"
                        alignItems="center"
                    >

                    <Button
                        size = "large"
                        className="logo-button"
                        onClick={() => setShow(!show)}

                    ></Button>

                    </Grid>
                
                </Container>           

            </Toolbar>
            <Toolbar 
                className="toolbar"
                style={{
                    display: show ? 'block' : 'none'
                }}
            >
                <Container
                >
                    <Grid
                        container
                        direction="row"
                        align = "center" justifyContent = "center" alignItems = "center"
                    >
                        <Grid
                            item
                            xs={3}
                        >
                             <MenuItemButton> TJÄNSTER </MenuItemButton>
                        </Grid>

                        <Grid
                            item
                            xs={3}
                        >
                             <MenuItemButton> OM OSS </MenuItemButton>
                        </Grid>

                        <Grid
                            item
                            xs={3}
                        >
                             <Button 
                                variant="outlined"
                                style={{
                                    color: `whitesmoke`,
                                    borderColor: 'whitesmoke',
                                    borderRadius:'15px',
                                    borderWidth: '1px'
                                }}
                                    
                            >KONTAKT</Button>
                        </Grid>
               
                    </Grid>
                
                </Container>           


            </Toolbar>
        </>

    )
}